import { DataProp } from 'editorjs-blocks-react-renderer';
import { StrapiFile } from 'src/common/models/strapiFile';
import { StrapiItemResponse } from './strapi';

export enum StaticPageCode {
  AboutUs = 'about-us',
  CookiesPolicy = 'cookies-policy',
  PrivacyPolicy = 'privacy-policy',
  TermsAndConditions = 'terms-and-conditions',
}

export interface StaticPageAttachment {
  file: StrapiItemResponse<StrapiFile>;
  id: string;
  text: string;
}

export interface StaticPageContent {
  content: DataProp;
  id: string;
  heading: string;
}

export interface StaticPagePanelItem {
  id: string;
  title: string;
}

export interface StaticPageSection {
  content: DataProp;
  id: string;
  title: string;
}

export type StaticPageDTO = StrapiItemResponse<{
  attachment: StaticPageAttachment | null;
  content: StaticPageContent[];
  intro?: DataProp;
  title: string;
  updatedAt: string;
}>;
